<template>
    <div class="mask">

    </div>
</template>

<script>
    export default {
        name: '',
        data () {
            return {

            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .clear {overflow: hidden;}
    .clearfix:before, .clearfix:after {clear: both;content: " ";display: table;}

    .mask{width:100%;height: 100%;background: #000;opacity: 0.5;position: fixed;left: 0;top: 0;z-index: 5}
</style>



// WEBPACK FOOTER //
// src/components/Mask/Mask.vue